import axios from "axios";
import { MainCategory } from "../types/service";
import axiosInstance from "../api/axiosInstance";
const baseUrl = import.meta.env.VITE_API_URL;

const api = axios.create({
  baseURL: baseUrl, // Replace with your actual API base URL
  timeout: 7000,
  withCredentials: true
});

export const getDataFromHomeApi = async () => {
  try {
    const response = await api.get(`/api/openRoute/home`, { withCredentials: true });
    if (response.data && response.data.HomeData) {
      return response.data
    }

    return null; // Return null if data is not available
  } catch (error) {
    console.error("Error fetching API data: home", error);
    return null; // Return null in case of an error
  }
};


export type ApiComponent = {
  name: string;
  props: Record<string, any> & { info?: { section_position?: number } };
  section_position?: number;
};

export type Activity = {
  categoryID: number;
  slug: string;
  name: string;
  iconUrl: string;
  subActivities: Activities[];
}

export type Activities = {
  activityID: number;
  activityCode: string;
  name: string;
  groupName: string;
  licenseType: string;
  description: string;
  categoryID: number;
  approval: number;
}

export type ApiResponse =
  | { components: ApiComponent[] }                 // /Home style
  | { HomeData: { components: ApiComponent[] } };  // /api/home style

export type ActivityDetail = {activity: Activities, groupActivity: Activities[]};

export async function getDataFromHomePageApi(
  signal?: AbortSignal
): Promise<ApiComponent[] | null> {
  const { data } = await api.get("/api/home", {
    withCredentials: true,
    signal, // ← enables cancellation via AbortController
  });

  if (!data) return null;
  if (Array.isArray((data as any).components)) return (data as any).components;
  if ((data as any).HomeData?.components) return (data as any).HomeData.components;

  return null;
}

export async function getDataForDedActivityCategoryPageApi(): Promise<Activity[]> {
  const { data } = await api.get("/api/services/activityCategory", { withCredentials: true }); 
  if (!data) return [];
  return data;
}

export async function getDataForDedActivityListPageApi(activityUrl: string, activityGroup?: string | null): Promise<Activity> {
  let params = {};
  if(activityGroup) {
    params = {
      activityGroup
    }
  } else {
    params = {
      activityUrl
    }
  }
  const { data } = await api.get("/api/services/activityList", { withCredentials: true, params: params });
  if (!data) null;
  return data;
}

export async function getDataForDedActivityDetailPageApi(activityCode: string): Promise<ActivityDetail> {
  const { data } = await api.get("/api/services/activityDetail", { withCredentials: true, params: {activityCode: activityCode} });
  if (!data) null;
  return data;
}


export const getJsonData = async (jsonUrl: string) => {
  try {
    const response = await axios.get(jsonUrl);
    if (response.data) {
      return response.data
    }

    return null; // Return null if data is not available
  } catch (error) {
    console.error("Error fetching JSON data:", error);
    return null; // Return null in case of an error
  }
};

export const fetchServices = async (baseUrl: string, slug?: string) => {
  try {
    if (!baseUrl) throw new Error("Base URL is not defined");

    const response = await axios.get(`${baseUrl}/api/services?slug=${slug}`, { withCredentials: true });
    if (response.status !== 200) throw new Error("Failed to fetch services");
    return response.data;
  } catch (error) {
    console.error("Error fetching services:", error);
    return null; // Return null on error
  }
};

export async function fetchBusinessForm() {
  const serviceId = sessionStorage.getItem("serviceid");
    const postData = {
      serviceId
    };

  const res = await axios.post(`${baseUrl}/api/services/questions`, postData, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true
      }
    );
  const json = res.data;
  if (!json.success) throw new Error(json.message || "Failed to load questions");
  return json;
}

export const submitBusinessForm = async (postData: any) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/services/enquiry`,
      postData,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true
      }
    );

    const data = await response;
    if (data) {
      return data
    }
  } catch (error) {
    console.error("postData Error enquiry not submitted:", error);
  }
};


export const getEmployeeImageUrl = (profilePic?: string, companyId?: string) => {
  if (!profilePic) return "https://goodhand.b-cdn.net/Assets/Home/staff/default.jpg";
  return `${baseUrl}/api/hrms-image/${profilePic}/${companyId}`;
};

export const getData = async (URL: string) => {
  try {
    const response = await axios.get(URL, { withCredentials: true });
    if (response.status === 200) {
      return response.data
    }
    return null;
  } catch (err) {
    console.error("Error fetching nav footer data:", err);
    return null;
  }
};

export const addDataToDataBasee = async (
  PriceRecordId: number,
  ServiceId: number,
  op: string,
) => {
  const UUID = localStorage.getItem("uuid");
  try {
    const postData = {
      ServiceId,
      Quantity: op === "plus" ? 1 : -1,
      PriceRecordId,
      UUID,
    };

    const response = await axios.post(
      `${baseUrl}/api/openRoute/addCart`,
      postData,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true
      }
    );

    const data = await response;
    if (data) {
      return data
    }
  } catch (error) {
    console.error("postData Error fetching user profile data:", error);
  }
};

export const extractSub1ServiceNames = (data: MainCategory[]): string[] => {
  return data.map((category) => category.sub1ServiceName);
};

export const getDataFromJson = async (jsonUrl: string) => {
  try {
    const response = await fetch(jsonUrl);
    const data = await response.json();
    if (data) {
      return data
    }
  } catch (error) {
    console.error("Error fetching JSON data:", error);
    return null
  }
};

export const fetchData = async (url: string) => {
  try {
    const response = await axios.get(url, { withCredentials: true });
    return response.data
  } catch (error) {
    console.error("Error fetching data:", error);
    return error
  }
};

export const getFilesDataToUpload = async (UUID: string, applicant_Name: string) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/cart/getFilesDataToUpload`,
      {
        params: { UUID, applicant_Name },
        withCredentials: true
      }
    );
    return response.data; // Return the API response data
  } catch (error) {
    console.error("Error fetching file data:", error);
    return null; // Return null in case of an error
  }
};

function base64ToBlob(base64: any, mimeType: any) {
  const byteCharacters = atob(base64.split(',')[1]);
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i += 512) {
    const slice = byteCharacters.slice(i, i + 512);
    const byteNumbers = new Array(slice.length);
    for (let j = 0; j < slice.length; j++) {
      byteNumbers[j] = slice.charCodeAt(j);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: mimeType });
}

export function base64ToFile(base64: any, fileName: any) {
  const mimeType = base64.match(/data:(.*);base64/)[1]; // Extract MIME type
  const blob = base64ToBlob(base64, mimeType);
  return new File([blob], fileName, { type: mimeType });
}

export const getFromLocalStorage = (key: string): string | null => {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
};

export const getDataFromLocalStorage = (key: string): any | null => {
  const value = localStorage.getItem(key);
  if (!value) return null; // Return null if there's no stored value

  try {
    return JSON.parse(value); // Try parsing as JSON
  } catch (error) {
    return value; // If parsing fails, return the raw string
  }
};

export const getDataFromLocalStorageB = <T = any>(key: string): T | null => {
  const value = localStorage.getItem(key);
  
  if (!value) return null;

  try {
    return JSON.parse(value) as T;
  } catch (error) {
    console.error(`Invalid JSON in localStorage under key "${key}":`, value);
    return null;
  }
};

export const setDataToLocalStorage = (key: string, value: any): void => {
  localStorage.setItem(key, JSON.stringify(value));
};


export const getDataFromSessionStorage = (key: string): any | null => {
  const value = sessionStorage.getItem(key);
  return value ? JSON.parse(value) : null;
};

export const setDataToSessionStorage = (key: string, value: any): void => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const removeItemFromSessionStorage = (key: string) => {
  sessionStorage.removeItem(key); // Remove from session storag
};

export const removeItemFromLocalStorage = (key: string) => {
  localStorage.removeItem(key); // Remove from session storag
};

export const getFooterPageTypeBySlug = async (apiUrl: string) => {
  const { data } = await axios.get(`${apiUrl}`, { withCredentials: true });
  return data;
};

export const fetchDepartmentData = async (apiUrl: string) => {
  const { data } = await axios.get(`${apiUrl}`, { withCredentials: true });
  return data;
};

export const updatedCustomerAddress = async(postData: any) => {
  const { data } = await axiosInstance.put(`/api/user/userAddressUpdate?id=${postData.RecordId}`, postData);
  return data;
};

export  const getCustomerAddress = async(postData: any) => {
  const { data } = await axiosInstance.post(`/api/user/userAddressShow`, postData);
  return data;
};

export  const getAccountFaqs = async() => {
  const { data } = await axiosInstance.get(`/api/user/accountFaqs`);
  return data;
};